import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import { get } from 'lodash';
import { getBodyHeight, getLogoProp } from 'utils';
import { handleAnswer } from '../utils/handleSenior';
import AccuracyRing from '../evaluation_report/common/accuracy_ring';
import styles from './styles';

const schoolInfo = [
  { name: '其它', img: `${require('./assets/其它@2x.png')}` },
  { name: 'B+类', img: `${require('./assets/B+@2x.png')}` },
  { name: 'A类', img: `${require('./assets/A@2x.png')}` },
  { name: 'A+类', img: `${require('./assets/A+@2x.png')}` },
];

// 报告
class SeniorReport extends Component {
  // 参数
  static propTypes = {
    report: PropTypes.object.isRequired,
    logo: PropTypes.object.isRequired,
  };
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      date: '',
      subjectInfo: [],
      schoolSuggest: { name: 'A+类', img: `${require('./assets/A+@2x.png')}` },
      style: {},
    };
  }

  componentDidMount() {
    const { report } = this.props;
    const result = handleAnswer(get(report, 'questionBackup'));
    // 对报告页数据分组处理
    const regex = /\d{4}-\d{2}-\d{2}/;
    const date = get(report, 'createdAt').match(regex)[0];
    const totalScore = result.reduce((total, item) => total + item.score, 0);
    let schoolSuggest;
    if (totalScore >= 70) {
      [,,, schoolSuggest] = schoolInfo;
    } else if (totalScore >= 60 && totalScore < 70) {
      [,, schoolSuggest] = schoolInfo;
    } else if (totalScore >= 50 && totalScore < 60) {
      [, schoolSuggest] = schoolInfo;
    } else {
      [schoolSuggest] = schoolInfo;
    }
    this.setState({ subjectInfo: result, schoolSuggest, date: date.replace(new RegExp(/-/g), '.') });
    const style = getBodyHeight() >= 1080 ? { position: 'absolute', bottom: 0, left: 0 } : {};
    this.setState({ style });
    global.window.onresize = () => {
      if (getBodyHeight() >= 1080) {
        this.setState({ style: { position: 'absolute', bottom: 0, left: 0 } });
      } else { this.setState({ style: {} }); }
    };
  }

  // 渲染总分
  renderScore() {
    const { subjectInfo } = this.state;
    const subjectInfo1 = [{
      name: '总分',
      score: subjectInfo.reduce((total, item) => total + item.score, 0),
    }].concat(subjectInfo);
    return (
      <View className={styles.surveyContainer}>
        <View className={styles.scores}>
          {
            subjectInfo1.length && subjectInfo1.map((item, index) => (
              <View className={styles.score} key={index}>
                <View
                  className={[styles.scoreItem, index !== 0 ? styles.subjectScore : styles.totalScore]}
                > {item.score}
                </View>
                <View className={styles.scoreTitle} >{item.name}</View>
                {
                  index !== 4 &&
                  <View className={styles.interval} />
                }
              </View>
          ))
          }
        </View>
      </View>)
  }

  // 渲染测评正确率
  renderSubject() {
    const { subjectInfo } = this.state;
    return (
      <View className={styles.subjectContainer}>
        {
          subjectInfo.map((item, index) => (
            <View className={styles.subject} key={index}>
              <View className={styles.subjectTitle}>{item.name}</View>
              <View className={styles.accuracy}>
                <AccuracyRing
                  accuracy={item.correct / item.count}
                  componentType="senior"
                  type={item.name}
                />
              </View>
              <View className={styles.answer}>答对&nbsp;<span className={css(styles.correct)}>{item.correct}</span> /{item.count}&nbsp;道题</View>
            </View>
          ))
        }

      </View>
    )
  }

  // 渲染
  render() {
    const { schoolSuggest, date, style } = this.state;
    const { logo } = this.props;
    const logoProp = getLogoProp({ image: logo.data.image, styles });
    return (
      <View className={styles.seniorContainer} >
        <View className={styles.header}>
          <View className={styles.headerTitle} >
            <Image {...logoProp} />
          </View>
          <Image src={require('./assets/title_senior1.png')} className={styles.title} />
          <View className={styles.date}>{date}</View>
        </View>
        <View className={styles.body}>
          {this.renderScore()}
          {this.renderSubject()}
          <View className={styles.suggestContainer}>
            <View className={styles.suggest}>
              <View className={styles.recommend}>根据你的答题结果，为你推荐的院校为
                <span className={css(styles.suggestSchool)}>
                  上海 {schoolSuggest.name}
                  国际学校
                </span>
              </View>
              <View className={styles.tip}>注：此建议仅做参考，具体建议需由智课规划老师详细评估你的考试结果后生成。</View>
            </View>
            <View className={styles.school} style={{ backgroundImage: `url(${schoolSuggest.img})` }}>上海 {schoolSuggest.name}<br />国际学校</View>
          </View>
        </View>
        <View
          className={styles.bottom}
          style={style}
        >
          &copy;2011-2019  北京创新伙伴教育科技有限公司|京ICP备13047080号
        </View>
      </View>
    );
  }
}

export default connect(state => ({ logo: state.logo }))(SeniorReport);




// WEBPACK FOOTER //
// ./src/components/report/senior_report/index.js